import customAxios from "../../customHook/customAxios";
import { getAuthHeader } from "../../utils";

export const v3_modules = async (page, limit) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/module/${page}/${limit}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}
export const v3_module_assign = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/module-role`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_mapped_modules = async (designationId) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/mapped-modules/${designationId}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

